import { BannerTypes } from '@gin-betting/banners';
import { map, times } from 'lodash';
import React from 'react';

import type { WidgetType } from '../../../types';
import { NUMBER_OF_ROWS } from '../../../constants';
import Header from '../Header';
import MatchRow, { StubMatchRow } from '../MatchRow';
import SportTabs from '../SportTabs';
import useTopMatch from './useTopMatch';
import './topMatch.scss';

interface Props {
    type: WidgetType;
    zoneAttributes: BannerTypes.BannerZoneAttributes[];
}

const TopMatch: React.FC<Props> = ({ type, zoneAttributes }) => {
    const {
        isShowTopMatch,
        activeZoneLocation,
        makeHandleChangeZoneLocation,
        zoneLocations,
        activeSport,
        makeHandleChangeSport,
        sportEventIds,
        containerRef,
        countRenderMarkets,
        sportIds,
        isNarrow,
    } = useTopMatch({ zoneAttributes });

    if (!isShowTopMatch) return null;

    return (
        <div styleName="container" ref={containerRef}>
            <Header
                activeZoneLocation={activeZoneLocation}
                widgetType={type}
                zoneLocations={zoneLocations}
                makeHandleChangeZoneLocation={makeHandleChangeZoneLocation}
            />

            <SportTabs
                sports={sportIds}
                activeSport={activeSport}
                makeHandleChangeSport={makeHandleChangeSport}
                isNarrow={isNarrow}
            />

            {map(sportEventIds, (sportEventId, index) => (
                <MatchRow
                    key={sportEventId}
                    matchId={sportEventId}
                    countRenderMarkets={countRenderMarkets}
                    hasMatchHeader={index === 0}
                />
            ))}

            {times(NUMBER_OF_ROWS - sportEventIds.length).map(idx => (
                <StubMatchRow key={idx} />
            ))}
        </div>
    );
};

export default TopMatch;
